import Ltc from './Ltc';

export default Ltc;